import { IInfoCardHelp } from '@app/core/interfaces/info-card-help';

export const helpCardModel: Array<IInfoCardHelp> = [
    {
        alt: 'help_center_first_button',
        title: 'help_center_first_button',
        imageUrl: '/assets/images/help/faq.svg',
        titleCard: 'help_center_first_button',
        linkCard: '/ayuda#faq'
    },
    {
        alt: 'help_center_second_button',
        title: 'help_center_second_button',
        imageUrl: '/assets/images/help/warranty.svg',
        titleCard: 'help_center_second_button',
        linkCard: '/wiki/warranty'
    },
    {
        alt: 'help_center_third_button',
        title: 'help_center_third_button',
        imageUrl: '/assets/images/help/deals.svg',
        titleCard: 'help_center_third_button',
        linkCard: '/wiki/deals'
    }
];

export const relatedSaldoNewsModel: Array<IInfoCardHelp> = [
    {
        alt: 'un-logo',
        title: 'related_un_new_text',
        imageUrl: '/assets/images/press/logos/un-logo.png',
        titleCard: 'related_un_new_text',
        linkCard: 'https://ultimasnoticias.com.ve/noticias/fintech/saldoar-venezuela/'
    },
    {
        alt: 'forbes-logo',
        title: 'related_forbes_new_text',
        imageUrl: '/assets/images/press/logos/forbes-logo.png',
        titleCard: 'related_forbes_new_text',
        linkCard: 'https://www.forbesargentina.com/money/guia-definitiva-como-exportar-servicios-evitar-pesificacion-oficial-n7978'
    },
    {
        alt: 'iproup-logo',
        title: 'related_iproup_new_text',
        imageUrl: '/assets/images/press/logos/iproup-logo.png',
        titleCard: 'related_iproup_new_text',
        linkCard: 'https://www.iproup.com/finanzas/18141-dolar-blue-y-cuevas-online-como-operar-en-saldos-com-ar-y-airtm'
    },
    {
        alt: 'tf-logo',
        title: 'related_tiempo_final_new_text',
        imageUrl: '/assets/images/press/logos/tf-logo.png',
        titleCard: 'related_tiempo_final_new_text',
        linkCard: 'https://tiempofinanciero.com.ar/reviews/billeteras-virtuales/saldo/'
    }
];
